export default __webpack_public_path__ + "static/media/delete.b69426d5.svg";